import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import GlobeIcon from 'mdi-react/GlobeIcon'
import PinIcon from 'mdi-react/PinIcon'

import { Translation } from '@/app/translations/Translation'
import Highlight from '@/components/Highlight'
import { TrLink } from '@/components/TrLink'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'
import type { Policy } from '@/types'
import { APP_ROUTES } from '@/util/app-routes'

const PolicyListItem: FC<Policy & { searchFilter: string }> = ({
  id,
  name,
  description,
  customerHeadName,
  customerName,
  vendorName,
  coverAmount,
  currency,
  searchFilter,
  isActive,
}) => {
  const { formatNumber } = useFormattedNumberWithCurrency()

  return (
    <TrLink
      path={APP_ROUTES.HARDWARE_ECOM_POLICY.replace(':ecomPolicyId', String(id))}
      className={`ecom-policy-list-item ${!isActive ? 'inactive' : ''}`}
    >
      <Td className="name">
        <Highlight pattern={searchFilter} text={name} />
        <span className="block text-xs text-gray-400">
          <Highlight pattern={searchFilter} text={description} />
        </span>
      </Td>

      <Td className="mobile-view">
        <div className="mobile-view__name">
          <Highlight pattern={searchFilter} text={name} />
          <span className="block text-xs text-gray-400">
            <Highlight pattern={searchFilter} text={description} />
          </span>
        </div>

        <div className="mobile-view__covered-amount">
          <Translation id="Covered amount:" />{' '}
          <Highlight pattern={searchFilter} text={formatNumber({ amount: coverAmount || 0 })} />
        </div>

        <div className="mobile-view__customer flex items-center">
          <Highlight pattern={searchFilter} text={customerHeadName || customerName} />
          {customerHeadName ? (
            <GlobeIcon className="ml-1 h-3 w-3 fill-gray-500 md:h-4 md:w-4" />
          ) : (
            <PinIcon className="ml-1 h-3 w-3 fill-gray-500 md:h-4 md:w-4" />
          )}
        </div>
      </Td>

      <Td className="customer flex items-center">
        <Highlight pattern={searchFilter} text={customerHeadName || customerName} />
        {customerHeadName ? (
          <GlobeIcon className="ml-1 h-3 w-3 fill-gray-500 md:h-4 md:w-4" />
        ) : (
          <PinIcon className="ml-1 h-3 w-3 fill-gray-500 md:h-4 md:w-4" />
        )}
      </Td>

      <Td className="price-list">
        <Highlight pattern={searchFilter} text={vendorName} />
      </Td>

      <Td className="covered-amount text-right">
        <Highlight
          pattern={searchFilter}
          text={formatNumber({ amount: coverAmount || 0, currency })}
        />
      </Td>
    </TrLink>
  )
}

export default PolicyListItem
